import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import SpeedConverter from '../components/tools/SpeedConverter';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'mph to km/h Calculator | Speed Unit Converter | AUTOXIUM';
const PAGE_DESCRIPTION = 'Convert speed instantly between mph, km/h, and m/s. Free online speed calculator for vehicle dynamics and simulation, with formulas and adjustable precision.';

const SpeedConverterPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="speed-converter-page">
      <PageHero
        eyebrow="Engineering Utilities / Conversion"
        title="mph ↔ km/h Calculator"
        description="Convert speed between Miles per Hour, Kilometers per Hour, and Meters per Second. Enter a value in any unit and the other two update in real time."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="speed-converter-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <SpeedConverter />
          <ToolGuideCta guidePath="/tools/speed-calculator/guide" toolName="mph ↔ km/h Calculator" />
        </div>
      </section>
    </div>
  );
};

export default SpeedConverterPage;
